import React, { memo, useEffect, useRef } from 'react';
import { View, TextInput, TouchableOpacity, StyleSheet } from 'react-native';
import { AntDesign } from '@expo/vector-icons';
import { fontFamily } from '../../../helpers/fontFamily';

const SearchBar = memo(({
  searchValue,
  onSearchChange,
  onClear,
  placeholder = 'Search...',
  windowWidth
}) => {
  const searchField = useRef(null);

  useEffect(() => {
    searchField.current?.focus();
  }, []);

  return (
    <View style={[styles.searchContainer, windowWidth < 768 && styles.searchContainerMobile]}>
      <TouchableOpacity testID="searchItemButton" style={styles.searchButton}>
        <AntDesign name="search1" size={18} color="#FFFFFF" />
      </TouchableOpacity>

      <TextInput
        ref={searchField}
        style={styles.searchInput}
        value={searchValue}
        onChangeText={onSearchChange}
        placeholder={placeholder}
        placeholderTextColor="gray"
        autoFocus={true}
      />

      {searchValue && searchValue.length > 0 && (
        <TouchableOpacity
          onPress={onClear}
          style={styles.clearButton}
          testID="clearSearchButton"
        >
          <AntDesign name="closecircle" size={17} color="gray" />
        </TouchableOpacity>
      )}
    </View>
  );
});

SearchBar.displayName = 'SearchBar';

const styles = StyleSheet.create({
  searchContainer: {
    position: 'relative',
    width: '100%',
    flexDirection: 'row',
    alignItems: 'center'
  },
  searchContainerMobile: {
    width: '100%'
  },
  searchButton: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: '#CCCDD0',
    height: 26,
    borderRadius: 10,
    borderTopRightRadius: 0,
    borderBottomRightRadius: 0,
    paddingLeft: 10,
    paddingRight: 4
  },
  searchInput: {
    flex: 1,
    height: 26,
    marginLeft: -7,
    paddingLeft: 25,
    paddingRight: 30,
    backgroundColor: '#CCCDD0',
    color: 'gray',
    borderRadius: 10,
    fontSize: 14,
    fontFamily: fontFamily.font300,
    outlineStyle: 'none',
    borderWidth: 0
  },
  clearButton: {
    position: 'absolute',
    right: 8,
    padding: 4
  }
});

export default SearchBar;
